import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCatalogsType } from "../../store/catalog/actions";

export const GetCatalogsType = (
  trigger: boolean,
  enable: boolean,
  page: number,
  limit: number,
  type: string,
) => {
  const dispatch = useDispatch();

  const {
    responseGetCatalogsType,
    loadingGetCatalogsType,
    errorGetCatalogsType,
  } = useSelector((state: any) => ({
    responseGetCatalogsType: state.Catalog.responseGetCatalogsType?.data,
    loadingGetCatalogsType: state.Catalog.loadingGetCatalogsType,
    errorGetCatalogsType: state.Catalog.errorGetCatalogsType,
  }));

  useEffect(() => {
    if (trigger) {
      dispatch(
        getCatalogsType({
          enable,
          page,
          limit,
          type,
        }),
      );
    }
  }, [trigger, enable, page, limit, type]);

  return {
    responseGetCatalogsType,
    loadingGetCatalogsType,
    errorGetCatalogsType,
  };
};
